import ProjectIcon from 'icons/ProjectIcon';
import { ReactComponent as FolderIcon } from 'icons/folder.svg';
import { ReactComponent as FileIcon } from 'icons/file.svg';
import type { StorageUnit } from 'store/storageunits/types';
import { StorageUnitType } from 'store/storageunits/types';

type IsProjectCheck = (unit: StorageUnit) => boolean;

export const getStorageUnitIcon = (
  unit: StorageUnit,
  isProject: IsProjectCheck,
) => {
  if (isProject(unit)) {
    return <ProjectIcon />;
  }
  if (unit.type === StorageUnitType.Folder) {
    return <FolderIcon />;
  }
  return <FileIcon />;
};
